export default __webpack_public_path__ + "static/morningfresh-c05aa28eec492753b4f06a014b1252c8.png";